import React from 'react';
import { Box, Button, Container, Typography, useTheme, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Error as ErrorIcon, ArrowBack } from '@mui/icons-material';

const AccessDenied: React.FC = () => {
  const theme = useTheme();

  return (
    <Container component="main" maxWidth="md" sx={{ height: '100vh', display: 'flex', alignItems: 'center' }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          borderRadius: 2,
          background: theme.palette.mode === 'dark' 
            ? 'rgba(30, 30, 30, 0.9)' 
            : 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(10px)',
          boxShadow: theme.palette.mode === 'dark' 
            ? '0 8px 32px rgba(0, 0, 0, 0.5)' 
            : '0 8px 32px rgba(145, 158, 171, 0.24)'
        }}
      >
        <ErrorIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
        
        <Typography variant="h4" component="h1" gutterBottom align="center" fontWeight="bold">
          Acesso Negado
        </Typography>
        
        <Typography variant="body1" align="center" sx={{ mb: 4, maxWidth: 450 }}>
          Você não tem permissão para acessar esta página. Entre em contato com o administrador do sistema se acredita que isto é um erro.
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            color="primary"
            startIcon={<ArrowBack />}
            sx={{ py: 1.5, px: 3, borderRadius: 1.5 }}
          >
            Voltar para a página inicial
          </Button>
          
          <Button
            component={RouterLink}
            to="/login"
            variant="outlined"
            sx={{ py: 1.5, px: 3, borderRadius: 1.5 }}
          >
            Voltar para o login
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default AccessDenied; 